<template>
    <MultiEmailList
        :saving="saving"
        group="invoice_emails"
        headingText="§ui_button.show_invoice_email"
        placeholder="§ui.placeholder_input_invoice_email"
    />
</template>

<script>
import MultiEmailList from './MultiEmailList.vue'

export default {
    name: 'InputsInvoicesEmails',

    components: {
        MultiEmailList,
    },

    props: {
        saving: {
            type: Boolean,
            required: true,
        },
    },
}
</script>
